import {
  addDoc, collection, deleteDoc,
  doc, getFirestore, onSnapshot
} from "@firebase/firestore";
import {
  deleteObject, getDownloadURL,
  getStorage, ref, uploadBytes
} from "@firebase/storage";
import { useEffect, useState } from "react";
import app from "../firebase";

export type DocumentInfo = {
  name: string;
  id: string;
};

export async function uploadDocument(name: string, pdf: File) {
  if (!pdf.type.endsWith('pdf')) {
    throw new Error('Invalid filetype');
  }

  const docRef = await addDoc(collection(getFirestore(app), 'documents'), {
    name: name
  });
  await uploadBytes(ref(getStorage(app), `/documents/${ docRef.id }.pdf`), pdf);
}

export async function deleteDocument(id: string) {
  await deleteDoc(doc(getFirestore(app), `/documents/${ id }`));
  await deleteObject(ref(getStorage(app), `/documents/${ id }.pdf`));
}

export async function getDocumentDownloadUrl(id: string) {
  return getDownloadURL(ref(getStorage(app), `/documents/${ id }.pdf`));
}

export function useExistingDocuments(): DocumentInfo[] {
  const [ docs, setDocs ] = useState<DocumentInfo[]>([]);

  useEffect(() => {
    const unsub = onSnapshot(collection(getFirestore(app), 'documents'), (newCollection) => {
      setDocs(newCollection.docs.map((doc) => {
        return {
          name: doc.get('name'),
          id: doc.id
        };
      }));
    });

    return () => unsub();
  }, []);

  return docs;
}
